import $ from 'jquery'

import Module from './lib/module'
import Util from './lib/util'

// Import global modules (run on every page)
import './modules/common'
import './modules/inputs'

global.$ = global.jQuery = window.$ = window.jQuery = $

// make sure jquery exists
Util.ensureJQuery()

$().ready(
  () => Module.loadAll({ async: true })
)
